import { FormControlLabel, Radio } from "@mui/material";
import { useTranslate } from "@/hooks";
import { colorPrimary, colorSecondary } from "@/constants/colors";
import { Hint } from "@/HOC";
import { TCustomRadioProps } from "./CustomRadio.props";

const CustomRadio = ({ label, hint = "", hintPosition, ...props }: TCustomRadioProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Hint hint={hint} position={hintPosition}>
			<FormControlLabel
				{...props}
				sx={{
					".MuiTypography-root": {
						color: colorPrimary,
						fontFamily: "inherit",
						fontSize: 13,
						fontStyle: "inherit",
						fontWeight: "inherit",
						lineHeight: "inherit",
						letterSpacing: "inherit",
					},
					...props.sx,
				}}
				control={
					<Radio
						sx={{
							color: colorPrimary,
							paddingBlock: 0,
							"& .MuiSvgIcon-root": { fontSize: 20 },
							"&.Mui-checked": {
								color: colorSecondary,
							},
							"&.Mui-disabled": {
								color: "inherit",
								opacity: 0.7,
							},
						}}
					/>
				}
				label={translate(label)}
			/>
		</Hint>
	);
};

export default CustomRadio;
